// Merkan · Dokumente direkt in der App ansehen statt herunterladen.
// Ein Tipp auf ein Dokument öffnet sofort die Ansicht (ui/dokument-ansicht.tsx, einmal je Oberfläche eingehängt);
// die Datei wird währenddessen geladen oder erzeugt. Teilen und Herunterladen bleiben in der Ansicht möglich.
import type { TeilDatei } from './teilen';

export interface AnsichtAuftrag {
  /** Überschrift der Ansicht, z. B. „Rechnung RE-2026-10-0005“ */
  titel: string;
  /** Dateiname für Teilen und Herunterladen */
  dateiname: string;
  /** MIME-Typ, falls bekannt; sonst aus Blob oder Dateiendung */
  typ?: string | null;
  /** Lädt oder erzeugt die Datei */
  laden: () => Promise<Blob | TeilDatei>;
}

export interface AnsichtStand extends AnsichtAuftrag { id: number }

let stand: AnsichtStand | null = null;
let zaehler = 0;
const hoerer = new Set<() => void>();
const melden = () => hoerer.forEach((h) => h());

export const ansicht = {
  stand: (): AnsichtStand | null => stand,
  abonnieren(h: () => void): () => void { hoerer.add(h); return () => { hoerer.delete(h); }; },
  schliessen(): void { stand = null; melden(); },
};

/** Dokument in der Ansicht öffnen (PDF, Bild; andere Dateien bieten Teilen oder Herunterladen an) */
export function dokumentZeigen(a: AnsichtAuftrag): void {
  stand = { ...a, id: ++zaehler };
  melden();
}

/** Ob eine Datei in der Ansicht dargestellt werden kann */
export function anzeigbar(typ: string | null | undefined, name?: string | null): 'pdf' | 'bild' | null {
  const ty = (typ ?? '').toLowerCase();
  const n = (name ?? '').toLowerCase();
  if (ty.includes('pdf') || n.endsWith('.pdf')) return 'pdf';
  if (ty.startsWith('image/') || /\.(jpe?g|png|webp|gif|heic)$/.test(n)) return 'bild';
  return null;
}
